<template>
  <div
    :class="
      isNavPanelFullWidth ? 'general-wrapper' : 'general-wrapper-fill-space'
    "
  >
  <Header />
    

    <div class="center-container px-50">
      <NewCafeCard />

      <div class="one-column right-space">
        <IQOS class="statistic-block" :hideTitle="true">
          <div class="card-number white-text">{{ daily_summary.orders_count }}</div>
          <div class="card-comment">
            {{ $t('general.daily_summary.new_orders') }}
          </div>
        </IQOS>
        <IQOS class="statistic-block" :hideTitle="true">
          <div class="card-number yellow-text">{{ daily_summary.clients_count }}</div>
          <div class="card-comment">
            {{ $t('general.daily_summary.new_clients') }}
          </div>
        </IQOS>
        <LocalSystems class="iqos" v-if="areSubscriptionsLoaded" />
        <MarketPlaceModes class="iqos" v-if="isMarketplaceEnabled" />
      </div>

      <div class="one-column">
        <CafeProfileFilling />
        <!-- <StaticMenuLink />
        <StaticQueueID /> -->
      </div>

      <!-- <MarketplaceCard class="space-top" v-if="isMarketplaceEnabled" /> -->
    </div>
  </div>
</template>
<!-- <div class="row scrollable p-left-50">
      <div class="d-flex">
        <InsideModeCard class="space-top" />
        <PreorderModeCard class="space-top" />
        <DeliveryModeCard class="space-top" />
        <ReserveModeCard class="space-top" />
      </div>
    </div>-->

<!-- <div class="panel-container mr-30" :style="getModeCardStyle('delivery')">
      <div class="titles">
        <h2 class="panel-title c-lightgreen">DELIVERY</h2>
        <SlideToggle v-model="modeDelivery" />
      </div>
      <div class="main-panel c-white w-25" v-if="!isDeliveryActivated">
        <p>Онлайн замовлення з необхідною інформацією для доставки</p>
        <p class="text-left mt-40">
          + Єдиний маркетплейс для всіх закладів міста
          <br />
          <br />+ Користувачі бачать ваше меню онлайн
          <br />
          <br />+ Замовляють доставку
          <br />
          <br />+ Наявність безготівкової оплати
        </p>
        <form @submit.prevent="activateDelivery">
          <input
            type="text"
            v-model="delivery_promocode"
            placeholder="Введіть промокод"
            class="promocode w-100"
            required
          />
          <button class="btn-connect w-100" type="submit">Підключити</button>
        </form>
      </div>

      <div class="main-panel w-25" v-if="isDeliveryActivated" @click="go2Delivery()">
        <p class="c-white text-center">Онлайн замовлення з необхідною інформацією для доставки</p>
        <p class="c-lightgreen text-center" v-if="readyDelivery.total && cafe.modes.delivery">
          <br />Сервіс DELIVERY налаштований і готовий до роботи.
        </p>
        <p class="text-center mt-40" v-if="!readyDelivery.total && cafe.modes.delivery">
          <span class="c-red" v-if="!readyDelivery.menu">Меню не встановлено.</span>
          <span class="c-lightgreen" v-if="readyDelivery.menu">Меню встановлено.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyDelivery.address">Адреса закладу не встановлена.</span>
          <span class="c-lightgreen" v-if="readyDelivery.address">Адреса закладу встановлена.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyDelivery.payment">Оплата не налаштована.</span>
          <span class="c-lightgreen" v-if="readyDelivery.payment">Оплата налаштована.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyDelivery.schedule">Графік роботи не має робочих днів.</span>
          <span class="c-lightgreen" v-if="readyDelivery.schedule">Графік роботи налаштований.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyDelivery.waiters">Працівники не налаштовані.</span>
          <span class="c-lightgreen" v-if="readyDelivery.waiters">Працівники налаштовані.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyDelivery.notifications">Сповіщення не підключені.</span>
          <span class="c-lightgreen" v-if="readyDelivery.notifications">Сповіщення підключені.</span>
          <br />
          <br>
          <span class="c-red" v-if="!readyDelivery.geolocation">Зони доставки не налаштовані.</span>
          <span class="c-lightgreen" v-if="readyDelivery.geolocation">Зони доставки налаштовані.</span>
          
        </p>
      </div>
    </div>

    <div class="panel-container preorder mr-30" :style="getModeCardStyle('preorder')"> 
      <div class="titles">
        <h2 class="panel-title c-lightgreen">TAKEAWAY</h2>
        <SlideToggle v-model="modePreorder" />
      </div>
      <div class="main-panel m-0 w-25 c-white" @click="go2Preorder">
        <p class="text-center">Передзамовлення їжі з собою (takeaway)</p>
        <p class="c-lightgreen text-center" v-if="readyPreorder.total && modePreorder">
          <br />Сервіс TAKEAWAY налаштований і готовий до роботи.
        </p>
        <p class="text-center mt-40" v-if="!readyPreorder.total && modePreorder">
          <span class="c-red" v-if="!readyPreorder.menu">Меню не встановлено.</span>
          <span class="c-lightgreen" v-if="readyPreorder.menu">Меню встановлено.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyPreorder.address">Адреса закладу не встановлена.</span>
          <span class="c-lightgreen" v-if="readyPreorder.address">Адреса закладу встановлена.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyPreorder.payment">Оплата не налаштована.</span>
          <span class="c-lightgreen" v-if="readyPreorder.payment">Оплата налаштована.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyPreorder.schedule">Графік роботи не має робочих днів.</span>
          <span class="c-lightgreen" v-if="readyPreorder.schedule">Графік роботи налаштований.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyPreorder.waiters">Працівники не налаштовані.</span>
          <span class="c-lightgreen" v-if="readyPreorder.waiters">Працівники налаштовані.</span>
          <br />
          <br />
        </p>
      </div>
    </div>

    <div class="panel-container mr-30 inside" :style="getModeCardStyle('inside')" >
      <div class="titles">
        <h2 class="panel-title c-lightgreen">INSIDE</h2>
         <SlideToggle v-model="modeInside"/>
      </div>
      <div class="main-panel w-25 c-white" @click="go2Inside()">
        <p class="text-center">Бесконтактні замовлення через QR-коди</p>
        <p class="c-lightgreen text-center" v-if="readyInside.total && modeInside">
          <br />Сервіс INSIDE налаштований і готовий до роботи.
        </p>
        <p class="text-center mt-40" v-if="!readyInside.total && modeInside">
          <span class="c-red" v-if="!readyInside.menu">Меню не встановлено.</span>
          <span class="c-lightgreen" v-if="readyInside.menu">Меню встановлено.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyInside.payment">Оплата не налаштована.</span>
          <span class="c-lightgreen" v-if="readyInside.payment">Оплата налаштована.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyInside.schedule">Графік роботи не має робочих днів.</span>
          <span class="c-lightgreen" v-if="readyInside.schedule">Графік роботи налаштований.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyInside.waiters">Працівники не налаштовані.</span>
          <span class="c-lightgreen" v-if="readyInside.waiters">Працівники налаштовані.</span>
          <br />
          <br />
          <span class="c-red" v-if="!readyInside.tables">Зали і столи не налаштовані.</span>
          <span class="c-lightgreen" v-if="readyInside.tables">Зали і столи налаштовані.</span>
          
          <br />
          <br />
          <span class="c-red" v-if="!readyInside.stickers">Наклейки не активовані.</span>
          <span class="c-lightgreen" v-if="readyInside.stickers">Наклейки активовані.</span>
        </p>
        
      </div>
    </div>-->

<!-- <div class="panel-container mr-30 reserve" :style="getModeCardStyle('reserve')" >
      <div class="titles">
        <h2 class="panel-title c-lightgreen">RESERVE</h2>
         <SlideToggle v-model="modeReserve"/>
      </div>
      <div class="main-panel w-25 c-white" @click="go2Reserve()">
        <p class="text-center">Бронювання столику наперед</p>
        <p class="c-lightgreen text-center" v-if="readyReserve.total && modeReserve">
          <br />Сервіс RESERVE налаштований і готовий до роботи.
        </p>
        <p class="text-center mt-40" v-if="!readyReserve.total && modeReserve">
          <span class="c-red" v-if="!readyReserve.notifications">Сповіщення не налаштовані.</span>
          <span class="c-lightgreen" v-if="readyReserve.notifications">Сповіщення налаштовані.</span>
          <br />
          <br />
        </p>
      </div>
    </div>-->

<style scoped>
.card-number {
  font-size: 11.333333333333334vh;
  line-height: 13vh;
  display: flex;
  align-items: center;
}
.card-comment {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
}
.white-text {
  color: #ededed;
}
.yellow-text {
  color: #ffd2a8;
}
input.promocode {
  background: #ededed;
  /* color: #A4A3A1; */
  color: #1d1d1b;
  border-radius: 1vh;
  margin-top: 2.5vh;
  border: none;
  font-size: 2vh;
  padding: 1vh 0 1vh 2vw;
}

.btn-connect {
  background: #129b81;
  margin-top: 2.5vh;
  padding: 1vh 0;
  color: white;
  border-radius: 1vh;
  border: none;
  font-size: 2.2vh;
  cursor: pointer;
}

.title-block {
  display: flex;
  justify-content: space-between;
}

.w-20 {
  width: 20%;
}

.inside,
.preorder,
.delivery {
  display: inline-grid;
  grid-template-rows: -webkit-max-content;
  grid-template-rows: max-content;
  margin-right: 3.4vh;
  background: #464646;
}

.inside {
  /* opacity: 0.5; */
  margin-right: 3.4vh;
}

.mode-not-active {
  opacity: 0.5;
}

.delivery img {
  height: 6vh;
  width: auto;
}

.inside h3,
.preorder h3,
.delivery h3 {
  line-height: 0.8;
  font-size: 2.7vw;
  padding-bottom: 1.7vh;
}

.pt-3 {
  padding-top: 3.3vh !important;
}
.pt-4 {
  padding-top: 4vh !important;
}

.links h4 {
  font-size: 1.3vw;
}

.info {
  padding: 0 1.1vw !important;
  color: #ededed;
}

.status {
  border: 2px solid #11d180;
  color: #11d180;
  padding: 2vh 0;
  margin-top: 3.3vh;
  border-radius: 1vw;
}

span.address,
span.phone {
  color: #a4a3a1;
  padding-top: 0.5vh;
}

.m-orders {
  font-size: 1.2vw;
  font-weight: 100;
  padding-top: 2vh;
}

h2.amount {
  font-size: 3.5vw;
  font-weight: 500;
}

h2.amount small {
  font-size: 1.3vw;
}

img.edit {
  float: right;
  margin-top: 2vh;
  position: relative;
}

.panel-blocks {
  padding: 5.5vh 3.5vw 0 3.5vw;

  flex-flow: row nowrap;
  display: flex;
  background: #464646;
}

.sub-panels {
  padding: 0 0 0 0;
  height: auto;

  display: flex;
  background: #464646;
}

.mt-40 {
  margin-top: 4.5vh;
}

.sub-panels p {
  font-size: 1.7vh;
}

span.soon {
  position: absolute;
  display: block;
  bottom: 5%;
  opacity: 0.5;
  text-align: center;
  font-size: 3vh;
  left: 0;
  right: 0;
  margin: 0 auto;
}

p.lvl span {
  color: #11d180;
}

p.lvl {
  font-size: 1vw;
}

.subscription {
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 3.3vh 2.1vw;
  border-radius: 1.5vh;
  background: #1d1d1b;
}

.subscription button {
  background: #129b81;
  border: none;
  font-size: 1.5vw;
  color: white;
  border-radius: 0.5vw;
  text-align: center;
  margin-top: 4.1vh;
  padding: 1vh 0;
  width: 100%;
}

.subscription h4 {
  font-size: 1.3vw;
}

.subscription span {
  padding-top: 2.5vh;
}

.stats {
  height: 17vh;
  width: 100%;
  background: white;
}

.col-3 img {
  height: 170px;
  border-radius: 1vh;
  width: 170px;
}

h4.id-queue {
  font-weight: 600;
}

h4.id-queue span {
  color: #129b81;
}

.establishment {
  width: 100%;
}

.main-panel {
  overflow-y: auto;
  width: 100%;
  cursor: pointer;
  position: relative;
  margin: 0 auto;
  padding: 3.4vh;
  border-radius: 1.5vh;
  background: #1d1d1b;
}

.main-panel p {
  font-size: 2.2vh;
}

/* !!!! */
.panel-container {
  display: inline-grid;
  grid-template-rows: max-content;
  background: #464646;
}

.inside {
  margin-right: 3.4vh;
}

.ml-20 {
  margin-left: 35vh;
}

.top-panel {
  display: flex;
  width: 100%;
  max-width: 100%;
}

.panel-title {
  margin-bottom: 2.8vh;
}

.subscription-card-heighter {
  height: 100%;
}

.titles {
  align-items: baseline;
  display: flex;
  justify-content: space-between;

  width: 100%;
}

.subscription-title {
  position: relative;
  left: -1vw;
}
</style>

<script>
import NewCafeCard from "@/components/general/NewCafeCard.vue";
import CafeProfileFilling from "@/components/general/CafeProfileFilling.vue";

import InsideModeCard from "@/components/general/InsideModeCard.vue";
import PreorderModeCard from "@/components/general/PreorderModeCard.vue";
import DeliveryModeCard from "@/components/general/DeliveryModeCard.vue";
import ReserveModeCard from "@/components/general/ReserveModeCard.vue";

import MarketplaceCard from "@/components/general/MarketplaceCard.vue";

import MarketPlaceModes from "@/components/general/MarketPlaceModes.vue";
import LocalSystems from "@/components/general/LocalSystems.vue";

import StaticMenuLink from "@/components/general/StaticMenuLink.vue";
import StaticQueueID from "@/components/general/StaticQueueID.vue";

import SlideToggle from "@/components/SlideToggle.vue";

import RemoteScroller from "@/components/RemoteScroller.vue";

import IQOS from "@/components/IQOS.vue";

import StatsAPI from '@/api/stats'

export default {
  data() {
    return {
      debug: false,
      delivery_promocode: null,

      daily_summary: {
        clients_count: '...',
        orders_count: '...'
      },

      onboarding: true
    };
  },
  watch: {
    cafe() {
      this.fetchDailySummary();
    }
  },
  mounted() {
    // this.$router.push('/menus');
    this.fetchDailySummary();
  },
  methods: {
    activateDelivery() {
      this.$store
        .dispatch("activateDelivery", this.delivery_promocode)
        .then((ok) => {})
        .catch((error) => {
          alert("Промокод невірний.");
          this.delivery_promocode = null;
        });
    },
    go2Delivery() {
      this.$router.push("/delivery");
    },
    go2Preorder() {
      this.$router.push("/preorder");
    },
    go2Inside() {
      this.$router.push("/inside");
    },
    go2Reserve() {
      this.$router.push("/reserve");
    },
    getModeCardStyle(mode) {
      return {};

      let should_hide = false;
      if (mode == "delivery") {
        should_hide = this.readyDelivery.total && !this.modeDelivery;
      } else if (mode == "preorder") {
        should_hide = this.readyPreorder.total && !this.modePreorder;
      } else {
        should_hide = this.readyInside.total && !this.modeInside;
      }

      return {
        opacity: !should_hide ? "1" : "0.5",
      };
    },
    canShowModeCard(mode) {
      return this.$store.getters["worldwide/checkSystem"](mode);
    },
    fetchDailySummary() {
      StatsAPI.getDailySummary(this.cafe._id).then(data => {
        this.daily_summary = data.summary;
      }).catch(error => {
        console.error(error);
      })
    },
  },
  computed: {
    isNavPanelFullWidth() {
      return this.$store.getters.is_nav_panel_full_width;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    subscriptions() {
      return this.$store.state.subscriptions;
    },
    areSubscriptionsLoaded() {
      return this.subscriptions.inside || this.subscriptions.delivery;
    },
    billing_account() {
      return this.$store.state.billing_account;
    },
    isDeliveryActivated() {
      return this.$store.getters.isDeliveryActivated;
    },
    isMarketplaceEnabled() {
      return this.cafe.uses_comission;
    },
    readyDelivery() {
      return this.$store.getters.readyDelivery;
    },
    readyPreorder() {
      return this.$store.getters.readyPreorder;
    },
    readyInside() {
      return this.$store.getters.readyInside;
    },
    readyReserve() {
      return this.$store.getters.readyReserve;
    },

    modePreorder: {
      get() {
        if (!this.cafe.modes) return false;
        return this.cafe.modes.preorder;
      },
      set(value) {
        this.$store.commit("toggleCafeMode", {
          mode: "preorder",
          value,
        });
        this.$store.dispatch("saveCafe");
      },
    },
    modeDelivery: {
      get() {
        if (!this.cafe.modes) return false;
        return this.cafe.modes.delivery;
      },
      set(value) {
        this.$store.commit("toggleCafeMode", {
          mode: "delivery",
          value,
        });
        this.$store.dispatch("saveCafe");
      },
    },
    modeInside: {
      get() {
        if (!this.cafe.modes) return false;
        return this.cafe.modes.inside;
      },
      set(value) {
        this.$store.commit("toggleCafeMode", {
          mode: "inside",
          value,
        });
        this.$store.dispatch("saveCafe");
      },
    },
    modeReserve: {
      get() {
        if (!this.cafe.modes.reserve) return false;
        return this.cafe.modes.reserve;
      },
      set(value) {
        this.$store.commit("toggleCafeMode", {
          mode: "reserve",
          value,
        });
        this.$store.dispatch("saveCafe");
      },
    },
  },
  components: {
    NewCafeCard,
    MarketPlaceModes,
    LocalSystems,
    SlideToggle,
    RemoteScroller,
    InsideModeCard,
    PreorderModeCard,
    DeliveryModeCard,
    ReserveModeCard,
    MarketplaceCard,
    StaticMenuLink,
    StaticQueueID,
    IQOS,
    CafeProfileFilling
  },
};
</script>
